<template>
  <div class="p1">
    <PinchInActStore/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID" :style="toparea_visible">
        <div id="toparea" class="toparea-mic flexcenter">
          <div  class="flexcenter">
            <div id="inputarea" v-bind:style="{visibility:inputarea_visible}" class="item bgdgray bdgreen w300" :class="{'textmgray':isTextGray}">
              <div class="inputarea-speech">{{ inputString }}</div>
              <div class="mic-icon" :class="scoreNum"></div>
            </div>
            <div class="icon-skip" v-bind:class="{disabled:skipDisabled}" v-bind:style="{visibility:iconskip_visible}" v-on:click="skipQuestion"></div>
          </div>
        </div>
        <CommonAct ref="commonAct" :pathstep="pathstep" :activeType="activeType" :actChoice="false" :horizontalRow="false" :needsSwiper="true"
                   :isShowTextsParent="isShowTextsParent" :isShowVoicesParent="isShowVoicesParent" :scriptSystems="scriptSystems"
                   :isActivesParent="isActivesParent" :changeActives="changeActives"
                   :isCorrectsParent="isCorrectsParent" :changeIsCorrects="changeIsCorrects"
                   :isInCorrectsParent="isInCorrectsParent" :changeIsInCorrects="changeIsInCorrects"
                   :changeEndAct="changeEndAct" v-on:clickSound="clickSound" />
      </div>
    </div>
  </div>
</template>
<script>
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as mixinConstants from "@/mixin/constants";
import * as constants from "@/store/constants";

// コンポーネント
import CommonAct from "./CommonAct";
import PinchInActStore from "./PinchInActStore";

export default {
  name: "P1",
  props: {
    pathstep: Object,
    productLanguage: String,
    scriptSystems: Object
  },
  mixins: [
    common,
    runmode,
    audio
  ],
  data() {
    return {
      // 音声入力が有効かどうか
      voiceStatus: true,
      // Actのテキスト表示するかを判断するBoolean配列
      isShowTextsParent: [],
      // Actの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesParent: [],
      // Actがアクティブかどうかを判断するBoolean配列
      isActivesParent: [],
      soundPlay: false,
      soundPlaying: false,
      skipFlag: false,
      skipDisabled: false,
      exitFlag: false,
      nextActFlag: false,
      pause_flag: false,
      timer: null,
      r_timer: null,
      // 音声認識のタイムアウト回数
      sonic_timeout: 0,
      // 音声認識入力文字列
      inputString: "",
      // 音声認識のスコア
      scoreLevel: 0,
      // グレー文字
      isTextGray: true,
      // 選択されている字体
      selectedFont: 0,
      // 監視用のステータス(Active)
      changeActives: false,
      // 正解かを判断するBoolean配列
      isCorrectsParent: [],
      // 監視用のステータス(Correct)
      changeIsCorrects: false,
      // 不正解かを判断するBoolean配列
      isInCorrectsParent: [],
      // 監視用のステータス(InCorrect)
      changeIsInCorrects: false,
      changeEndAct: false,
      toparea_visible: "visibility:visible;",
      // 適用するレイアウトクラス
      activeType: "active-type2",
      soundPath: "",
      // 連続不正解回数
      incorrectTimes: 0,
      // 音声認識OFF時にTileに切り替えるべきかどうか
      changeTile: false,
      // スコア更新済みかどうか
      isUpdatedScore: false,
      inputarea_visible: "visible",
      iconskip_visible: "visible",
      // 正解音声再生済みかどうかのフラグ
      isPlayedCorrectSound: false,
      // given時の出題音声再生済みかどうかのフラグ
      isPlayedGivenSound: false,
      allCorrectTimer: null
    };
  },
  computed: {
    scoreNum: function() {
      return "score_" + this.scoreLevel;
    }
  },
  components: {
    CommonAct,
    PinchInActStore
  },
  created: function() {
    this.$store.dispatch("initPinchInAct");
    this.init();
  },
  mounted() {
    // 右から出題するレイアウト変換処理
    this.changeRtlLayout();

    if (this.isMobile()) {
      // スマホの場合は、sliderを初期化
      this.sliderInit();
      // 自動調整初期処理
      this.initAutoAdjust([".cards-container"], [".page-content"]);
    }

    // タイマー処理スタート
    this.timerTick();
  },
  beforeDestroy: function() {
    for (var i = 0; i < this.pathstep.acts.length; i++) {
      var act = this.pathstep.acts[i];
      act.correct = false;
      act.complate = false;
    }
  },
  watch: {
    lessonState: function(state) {
      if (state == constants.LESSON_STATE_STOP) {
        this.timerTick();
      } else if (state == constants.LESSON_STATE_PAUSE) {
        // レッスン停止
        this.lessonPause();
      } else if (state == constants.LESSON_STATE_RESTART) {
        // レッスンリスタート
        this.lessonRestart();
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log(this.pathstep.mode + " watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus) {
        // 一部コントロールを非表示にする
        this.inputarea_visible = "hidden";
        this.iconskip_visible = "hidden";
        // 出題の中断
        this.lessonPause();
      } else {
        // 一部非表示にしたコントロールの再表示
        this.inputarea_visible = "visible";
        this.iconskip_visible = "visible";
        // 出題の再開
        this.lessonRestart();
      }
    },
    /**
     * 中国語表示切り替え
     *
     * @param string newstatus
     */
    scriptType: function(newstatus) {
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * 表示モード切り替え
     *
     * @param string newstatus
     */
    displayMode: function(newstatus) {
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    }
  },
  methods: {
    /**
     * 初期処理
     */
    init: function() {
      this.log(this.pathstep.mode + " start init");

      this.voiceStatusCheck();

      this.initActStatus();
      this.initShowActText();
      this.initShowActVoice();
      this.initActives();

      this.soundPlaying = true;
      this.soundPlay = true;
    },
    /**
     *  音声入力が有効か調べる
     */
    voiceStatusCheck: function() {
      if (this.$store.getters.sreUse != "true") {
        this.voiceStatus = false;

        // 非表示のActのテキストを全て表示する
        this.showAllActText();

        if (this.pathstep.mode == mixinConstants.RUNMODE_PSPEECH ||
            this.pathstep.mode == mixinConstants.RUNMODE_SPEECH ||
            this.pathstep.mode == mixinConstants.RUNMODE_PNTSPEECH ||
            this.pathstep.mode == mixinConstants.RUNMODE_PNS) {
          // confusersが存在するactがあればRunmodeをTileに切り替える
          for (var i = 0; i < this.pathstep.acts.length; i++) {
            var act = this.pathstep.acts[i];
            for (var j = 0; j < act.texts.length; j++) {
              var text = act.texts[j];
              if (text.confusers.length != 0) {
                this.changeTile = true;
                this.$emit("changeTile");
                return;
              } else {
                this.changeTile = false;
              }
            }
          }
        }

        this.changeTile = false;
      } else {
        this.changeTile = false;
        this.voiceStatus = true;
      }
    },
    /**
     * 非表示のActのテキストを全て表示する
     */
    showAllActText: function() {
      for (var i = 0; i < this.pathstep.actNum; i++) {
        if (this.isShowTextsParent[i] != true) {
          this.isShowTextsParent[i] = true;
        }
      }
    },
    /**
     * 初期表示時に各Actのステータスを初期化する
     */
    initActStatus: function() {
      this.log(this.pathstep.mode + " start initActStatus");

      for (var i = 0; i < this.pathstep.actNum; i++) {
        // 出題状況初期化
        this.pathstep.acts[i].correct = false;
        // 正解状況初期化
        this.pathstep.acts[i].complate = false;
      }
    },
    /**
     * 初期表示時に各Actのテキストを表示するかを判定する
     */
    initShowActText: function() {
      this.log(this.pathstep.mode + " start initShowActText");

      for (var i = 0; i < this.pathstep.actNum; i++) {
        if (this.pathstep.acts[i].textPolicy === "g" || this.pathstep.mode == mixinConstants.RUNMODE_PNS) {
          this.isShowTextsParent[i] = true;
        } else {
          this.isShowTextsParent[i] = false;
        }
      }
    },
    /**
     * 初期表示時に各Actの音声再生アイコンを表示するかを判定する
     */
    initShowActVoice: function() {
      this.log(this.pathstep.mode + " start initShowActVoice");

      for (var i = 0; i < this.pathstep.actNum; i++) {
        if (this.pathstep.acts[i].soundPolicy === "g") {
          this.isShowVoicesParent[i] = true;
        } else {
          this.isShowVoicesParent[i] = false;
        }
      }
    },
    /**
     * 初期表示時に各Actのactive状態を判定する
     */
    initActives: function() {
      this.log(this.pathstep.mode + " start initActives");
      this.isActivesParent[0] = true;
      for (var i = 0; i < this.pathstep.actNum; i++) {
        this.isActivesParent[i] = false;
      }
    },
    /**
     * タイマー処理
     */
    timerTick: function() {
      this.changeActives = false;

      // Tile切り替え時
      if (this.changeTile) {
        if (this.timer != null) {
          clearTimeout(this.timer);
        }
        return;
      }

      // レッスン停止時
      if (this.lessonState == constants.LESSON_STATE_STOP) {
        if (this.timer != null) {
          clearTimeout(this.timer);
        }
        if (this.isAudioPlaying && this.myAudio != null) {
          // 音声停止
          this.audioPause();
        }
        if (sonic_wrapper.isSessionRunning()) {
          // SREセッション実行中なら中断する
          sonic_wrapper.interruptSession();
        } else {
          this.log(this.pathstep.mode + " stop act");
          this.$emit("stopAct");
        }
        return;
      }

      // レッスン開始直前、または次のact実施中の場合
      if (this.lessonState === constants.LESSON_STATE_PREPARE || this.nextActFlag) {
        this.timer = setTimeout(this.timerTick, 10);
        return;
      }

      // レッスン中断時
      if (this.lessonState === constants.LESSON_STATE_PAUSE) {
        if (this.isAudioPlaying && this.myAudio != null) {
          if (!this.$store.getters.showPinchIn) {
            // 音声停止
            this.audioPause();
          }
        }
        if (this.exitFlag == false) {
          this.timer = setTimeout(this.timerTick, 10);
        }
        return;
      }

      // 全解答表示時
      if (this.dispAllAnswerStatus) {
        if (sonic_wrapper.isSessionRunning()) {
          // SREセッション実行中なら中断する
          sonic_wrapper.interruptSession();
        }
        this.timer = setTimeout(this.timerTick, 10);
        return;
      }

      // 音声入力の確認
      this.voiceStatusCheck();

      // スキップ時
      if (this.skipFlag) {
        this.skipProcess();
      } else {
        if (this.soundPlay && this.isAudioPlaying) {
          this.soundPlaying = true;
        }
        if (this.soundPlaying && !this.isAudioPlaying) {
          this.soundPlay = false;
          this.soundPlaying = false;

          // ◯×を消す
          this.changeIsCorrects = false;
          this.changeIsInCorrects = false;

          // スキップボタンを活性にする
          this.skipDisabled = false;

          // テキスト、音声再生ボタン非表示の確認
          this.checkHide();

          if (this.currentActIndex >= this.pathstep.actNum) {
            setTimeout(this.checkNextQuestion, mixinConstants.ALLCORRECT_INTERVAL);
            return;
          } else if (!this.isChallenge(this.currentAct)) {
            // givenだった場合
            // 出題音声再生済みの場合
            if (this.isPlayedGivenSound) {
              // 次の問題へ
              this.soundPlaying = true;
              this.nextAct();
            } else {
              this.log("------- challenge none ------");

              this.setActive();
              // スライド
              var self = this;
              this.sliderToActiveAct(this.currentActIndex).then(function() {
                // 音声再生して次の問題へ
                self.autoPlay(self.pathstep.acts[self.currentActIndex].sounds[0], 1000);
                self.soundPlay = true;
                // スキップボタンを非活性にする
                self.skipDisabled = true;
                self.isPlayedGivenSound = true;
              });
            }
          } else if (this.isChallenge(this.currentAct)) {
            // challengeだった場合
            // 音声認識OFFの場合
            if (!this.voiceStatus) {
              // 正解音声再生済みの場合
              if (this.isPlayedCorrectSound) {
                // 次の問題へ
                this.soundPlaying = true;
                this.nextAct();
              } else {
                this.isTextGray = false;
                this.sonic_timeout = 0;
                this.setActive();
                // スライド
                var self = this;
                this.sliderToActiveAct(this.currentActIndex).then(function() {
                  // スコアを登録する
                  self.currentAct.complate = true;
                  self.setActState(self.currentAct.complate);
                  // PNS以外の場合、音声再生して次の問題へ
                  if (self.pathstep.mode != mixinConstants.RUNMODE_PNS) {
                    self.autoPlay(self.pathstep.acts[self.currentActIndex].sounds[0], 1000);
                  } else {
                    // PNSの場合、音声再生しないが、timer処理を継続するために、音声再生中のフラグをtrueに設定する
                    self.soundPlaying = true;
                  }
                  self.soundPlay = true;
                  self.isPlayedCorrectSound = true;
                });
              }
            } else {
              // 音声認識ONの場合
              // 正解音声再生済みの場合
              if (this.isPlayedCorrectSound) {
                // 次の問題へ
                this.soundPlaying = true;
                this.nextAct();
              } else if (this.currentAct.correct != true) {
                // 未出題の場合
                this.incorrectTimes = 0;
                this.beforeSetQuestionsProcess();
              } else if (this.currentAct.complate == true) {
                // 正解済みの場合
                this.afterCorrectActProcess();
              } else {
                // 未正解の場合
                if ((this.pathstep.mode == mixinConstants.RUNMODE_PSPEECH || this.pathstep.mode == mixinConstants.RUNMODE_SPEECH) && this.incorrectTimes >= 2) {
                  // 2回以上連続不正解
                  this.incorrectTimes = 0;
                  this.autoPlay(this.pathstep.acts[this.currentActIndex].sounds[0], 1000);
                  this.soundPlay = true;
                  this.isShowTextsParent[this.currentActIndex] = true;
                } else {
                  this.setVoiceInput();
                }
              }
            }
          }
        }
      }

      // 終了フラグが立っていなければ、再度タイマー処理を実施する
      if (!this.exitFlag) {
        this.timer = setTimeout(this.timerTick, 10);
      }
    },
    /**
     *  スキップボタン押下時
     */
    skipQuestion: function() {
      // スキップアイコンが活性時のみ、スキップフラグを設定する
      if (!this.skipDisabled) {
        this.log("skip!!");
        this.skipFlag = true;
        this.skipDisabled = true;
      }
    },
    /**
     * スキップ時の処理
     */
    skipProcess: function() {
      this.skipFlag = false;

      // 音声再生中の場合は、停止する
      if (this.isAudioPlaying) {
        this.audioPause();
        this.soundPlaying = true;
      }

      // textPolicyが「r」の場合、スキップ時に非表示のテキストを表示する
      if (this.currentAct.textPolicy === "r") {
        this.isShowTextsParent[this.currentActIndex] = true;
      }
      // soundPolicyが「r」の場合、スキップ時に非表示の音声再生ボタンを表示する
      if (this.currentAct.soundPolicy === "r") {
        this.isShowVoicesParent[this.currentActIndex] = true;
      }
      this.nextAct();
    },
    /**
     * 直前に表示した正解テキスト、または音声再生ボタンを
     * 非表示にするかどうか確認し、該当したら非表示にする
     */
    checkHide: function() {
      // １問目、または音声認識OFFの場合はチェックしない
      if (this.currentActIndex === 0 || !this.voiceStatus) {
        return;
      }

      // 直前の問題がchallengeかつ、textPolicyが「n」の場合、
      // テキスト表示は正解直後と全問終了後のみなので、ここで非表示にする
      if (this.pathstep.acts[this.currentActIndex - 1].usage === 1 && this.pathstep.acts[this.currentActIndex - 1].textPolicy === "n") {
        this.isShowTextsParent[this.currentActIndex - 1] = false;
      }

      // 直前の問題がchallengeかつ、soundPolicyが「n」の場合、
      // テキスト表示は正解直後と全問終了後のみなので、ここで非表示にする
      if (this.pathstep.acts[this.currentActIndex - 1].usage === 1 && this.pathstep.acts[this.currentActIndex - 1].soundPolicy === "n") {
        this.isShowVoicesParent[this.currentActIndex - 1] = false;
      }
    },
    /**
     * 問題のアクティブ状態を設定する
     */
    setActive: function() {
      this.log("setActive step=" + this.currentActIndex);

      if (this.currentActIndex < this.pathstep.actNum) {
        // 次の問題をアクティブに
        this.currentAct.isActive = true;
        this.isActivesParent[this.currentActIndex] = true;
      }

      if (this.currentActIndex > 0) {
        // 前の問題を非アクティブに
        this.pathstep.acts[this.currentActIndex - 1].isActive = false;
        this.isActivesParent[this.currentActIndex - 1] = false;
      }

      this.changeActives = true;

      // 入力エリアをクリア
      this.inputString = "";
      this.scoreLevel = 0;
      this.isTextGray = true;

      this.log("setActive end!!");
    },
    /**
     * 次の問題へ遷移する
     */
    nextAct: function() {
      this.log("next question!!");

      // 正解音声再生フラグをリセット
      this.isPlayedCorrectSound = false;
      // given時出題音声再生フラグをリセット
      this.isPlayedGivenSound = false;
      // スコア登録を判断するフラグをリセット
      this.isUpdatedScore = false;

      // 音声認識中の場合(スキップ時など)は、音声認識を中断する
      if (sonic_wrapper.isSessionRunning() && this.nextActFlag == false) {
        this.log("------ necxtAct::interruptSession");
        this.nextActFlag = true;
        if (this.currentActIndex === this.pathstep.acts.length - 1) {
          this.exitFlag = true;
        }
        sonic_wrapper.interruptSession();
        return;
      }

      // 次のactを設定
      if (!this.setNextAct()) {
        this.soundPlaying = false;

        // 音声認識オブジェクトとインジケータの表示をリセット
        this.inputString = "";
        this.scoreLevel = 0;
        this.isTextGray = true;

        // actが最後だった場合は、終了する
        this.log("------ setTimeout::checkNextQuestion");
        // 親(Runmode.Vue)に通知する
        this.changeEndAct = true;
        this.exitFlag = true;
        this.allCorrectTimer = setTimeout(this.checkNextQuestion, mixinConstants.ALLCORRECT_INTERVAL);
        return;
      }
    },
    /**
     *
     */
    checkNextQuestion: function() {
      this.log("------ checkNextQuestion");
      if (this.timer != null) {
        clearTimeout(this.timer);
      }

      if (sonic_wrapper.isSessionRunning()) {
        sonic_wrapper.interruptSession();
      } else {
        this.soundPlay = false;
        this.soundPlaying = false;

        this.log("end act");
        this.$emit("endAct");
      }
    },
    /**
     * 未出題時処理
     */
    beforeSetQuestionsProcess: function() {
      this.setActive();

      var self = this;
      this.sliderToActiveAct(this.currentActIndex).then(function() {
        // PNS、SPEECH、PSPEECHかつsoundPolicyがr、PNTSPEECHかつのsoundPolicyがrの場合は、出題時に音声再生しない
        if (self.pathstep.mode == mixinConstants.RUNMODE_PNS ||
            self.pathstep.mode == mixinConstants.RUNMODE_SPEECH ||
            ((self.pathstep.mode == mixinConstants.RUNMODE_PSPEECH || self.pathstep.mode == mixinConstants.RUNMODE_PNTSPEECH) && self.currentAct.soundPolicy === "r")) {
          self.soundPlaying = true;
        } else if (self.currentAct.soundPolicy != "n") {
          // 出題音声再生
          self.autoPlay(self.pathstep.acts[self.currentActIndex].sounds[0], 1000);
          self.soundPlay = true;
        }
      });

      this.currentAct.correct = true;
    },
    /**
     * 正解時処理
     */
    afterCorrectActProcess: function() {
      // 正解後の音声再生
      // IEの場合に音声再生されない問題に対応するため
      // 独自にAudioオブジェクトを生成して音声再生する
      var pAudio = new Audio();
      this.disabledIconVoice();
      var self = this;

      this.isAudioPlaying = true;
      this.soundPlay = true;
      pAudio.src = this.pathstep.acts[this.currentActIndex].sounds[0];
      pAudio.load();
      pAudio.play();
      var endedEvent = function(event) {
        $(pAudio).off("ended error", endedEvent);
        var errorCode = "";
        try {
          errorCode = event.currentTarget.error.code;
        } catch (e) {
          errorCode = "none";
        }
        self.log(self.pathstep.mode + " end pAudioPlay errorCode: " + errorCode);
        self.enabledIconVoice();
        self.isAudioPlaying = false;
      };
      $(pAudio).on("ended error", endedEvent);

      // 正解後のテキスト表示
      if (this.currentAct.textPolicy != "g") {
        this.isShowTextsParent[this.currentActIndex] = true;
      }

      // 正解直後の音声再生ボタン表示
      if (this.currentAct.soundPolicy != "g") {
        this.isShowVoicesParent[this.currentActIndex] = true;
      }

      // 正解音声再生フラグを設定
      this.isPlayedCorrectSound = true;
    },
    /**
     * 音声認識設定
     */
    setVoiceInput: function() {
      if (this.voiceStatus) {
        var act = this.pathstep.acts[this.currentActIndex];
        var phrases = this.getBasicTextByScriptid(act, this.scriptSystems.speech);
        var text = this.tagErase(phrases);
        this.listenForPhrases(text);

        this.scoreLevel = 0;
        this.isTextGray = true;
        this.inputString = "";
      } else {
        this.isTextGray = false;
        this.sonic_timeout = 0;
      }
    },
    /**
     *
     */
    lessonPause: function() {
      this.log("------ lesson pause -------");
      this.pause();
    },
    /**
     *
     */
    lessonRestart: function() {
      this.log("------ lesson restart ------");
      if (this.dispAllAnswerStatus == false) {
        this.resume();
      }
    },
    /**
     *
     */
    pause: function() {
      this.log("------ pause ------");

      this.pause_flag = true;

      if (sonic_wrapper.isSessionRunning()) {
        sonic_wrapper.interruptSession();
        return;
      } else {
        this.pauseMain();
      }
    },
    /**
     *
     */
    pauseMain: function() {
      if (this.audioPlaying && this.myAudio != null) {
        // 音声停止
        this.myAudio.pause();
      }
    },
    /**
     *
     */
    resume: function() {
      this.log("------ resume ------");

      // ◯×を消す
      this.changeIsCorrects = false;
      this.changeIsInCorrects = false;

      this.soundPlaying = true;
      this.audioPlaying = false;
      this.pause_flag = false;

      if (this.currentAct.complate === true) {
        this.nextAct();
      } else {
        this.currentAct.correct = false;
        this.currentAct.complate = false;
      }
    },
    /**
     * 音声解析実行
     */
    listenForPhrases: function(phrases) {
      this.log("P start listenForPhrases: " + phrases);

      // イベントと同じ名前で実行したい関数を指定する
      // 特に処理する必要のないイベントに関しては指定しない
      var callbacks = {
        start: this.listenForPhrasesStart,
        update: this.listenForPhrasesUpdate,
        error: this.listenForPhrasesError,
        interrupting: this.listenForPhrasesInterrupting,
        success: this.listenForPhrasesSuccess,
        end: this.listenForPhrasesEnd
      };

      sonic_wrapper.listenForPhrases([phrases], callbacks);

      this.updateFlag = false;
    },
    listenForPhrasesStart() {
      // startイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesStart");
    },
    listenForPhrasesUpdate() {
      // updateイベント発火時に行いたい処理を実装できる
      this.log("P start listenForPhrasesUpdate");
      if (sonic_wrapper.hasLfpHypothesisResponse()) {
        var response = sonic_wrapper.getLfpResponse();
        this.inputString = response;
        this.log("listenForPhrasesUpdate: " + response);
      }
      this.updateFlag = true;
    },
    listenForPhrasesError() {
      // errorイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesError");
    },
    listenForPhrasesInterrupting() {
      // interruptingイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesInterrupting");
    },
    listenForPhrasesSuccess() {
      // successイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesSuccess");
    },
    listenForPhrasesEnd() {
      // endイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesEnd");

      // 学習済登録
      this.$emit("updateLearnedGroup");

      if (this.nextActFlag) {
        this.log("------- listenForPhrasesEnd : nextAct -------");
        this.nextAct();
        this.soundPlaying = true;
        this.nextActFlag = false;
      } else if (sonic_wrapper.isStopReasonManual()) {
        this.log("------- sonic.globals.getSTOP_REASON_MANUAL -------");
        if (this.lessonState == constants.LESSON_STATE_STOP) {
          this.log("stop act");
          this.$emit("stopAct");
        } else if (this.exitFlag) {
          this.log("end act");
          this.$emit("endAct");
        } else if (this.pause_flag) {
          this.log("------- sonic.globals.getSTOP_REASON_MANUAL : pause -------");
          this.pauseMain();
        } else if (this.soundPath != "") {
          this.log("------- sonic.globals.getSTOP_REASON_MANUAL : sound play -------");
          this.autoPlay(this.soundPath, 10);
          this.soundPlay = true;
          this.soundPlaying = false;
          this.soundPath = "";
        }
      } else if (!sonic_wrapper.isCalibrationResultOk()) {
        // タイムアウト
        this.log("----- timeout ------ updateFlag=" + this.updateFlag);
        this.sonic_timeout++;
        this.scoreLevel = 0;
        if (this.sonic_timeout >= 2) {
          // タイムアウトが2回連続発生
          this.openMicDialog();
        } else {
          this.soundPlaying = true;
          this.audioPlaying = false;
        }
      } else {
        if (!this.updateFlag) {
          this.sonicTimeoutCount = 0;
          this.scoreLevel = 0;
          this.openMicDialog();
        } else if (!sonic_wrapper.isStopReasonManual()) {
          this.phraseCheck();
        }
      }
    },
    /**
     * マイク設定ダイアログを表示する
     */
    openMicDialog: function() {
      this.log("-------- mic dialog open ---------");
      this.sonic_timeout = 0;
      this.incorrectTimes = 0;
      this.$emit("showMicrophoneErrorDialog");
    },
    /**
     * 認識した音声の正誤を確認する
     */
    phraseCheck: function() {
      // スコア
      var score = 0;
      if (sonic_wrapper.hasLfpHypothesisScore()) {
        score = sonic_wrapper.getLfpScore();
        this.scoreLevel = score;
      }
      this.log("sre score: " + score);

      if (sonic_wrapper.getLfpPassed()) {
        this.log("------------ success!!!! ------------");

        // 正解音
        if (this.$store.getters.answerSound == "true") {
          this.autoPlay(mixinConstants.AUDIO_CORRECT, 10);
          this.soundPlaying = false;
        } else {
          // 正解音を再生しないが、timer処理を継続するために、音声再生中のフラグをtrueに設定する
          var self = this;
          setTimeout(function() {
            self.soundPlaying = true;
          }, mixinConstants.INCORRECT_INTERVAL);
        }

        this.isTextGray = false;
        this.sonic_timeout = 0;

        var obj = this.getTextObjByScriptID(this.currentAct.texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
        var phrases = obj.textObj.basicText;
        this.inputString = this.tagErase(phrases);

        this.soundPlay = true;

        // スコアを登録する
        if (!this.isUpdatedScore) {
          this.setActState(true);
          this.isUpdatedScore = true;
        }
        this.currentAct.complate = true;

        // 連続不正解回数初期化
        this.incorrectTimes = 0;

        // 正解画像の表示
        this.isCorrectsParent = [];
        this.isInCorrectsParent = [];
        this.isCorrectsParent[this.currentActIndex] = true;
        this.changeIsCorrects = true;
      } else {
        this.log("------------ bad!!!! ------------");

        // 連続不正解回数加算
        this.incorrectTimes++;

        // 不正解
        if (this.$store.getters.answerSound == "true") {
          this.autoPlay(mixinConstants.AUDIO_INCORRECT, 10);
          this.soundPlaying = false;
        } else {
          // 不正解音を再生しないが、timer処理を継続するために、音声再生中のフラグをtrueに設定する
          var self = this;
          setTimeout(function() {
            self.soundPlaying = true;
          }, mixinConstants.INCORRECT_INTERVAL);
        }

        this.soundPlay = true;

        // 2回連続不正解の場合、スコア更新
        if (this.incorrectTimes == 2) {
          if (!this.isUpdatedScore) {
            this.setActState(false);
            this.isUpdatedScore = true;
          }
        }

        // 不正解画像の表示
        this.isCorrectsParent = [];
        this.isInCorrectsParent = [];
        this.isInCorrectsParent[this.currentActIndex] = true;
        this.changeIsInCorrects = true;
      }
    },
    /**
     * Actクリックまたは音声再生ボタンクリック時に、
     * 子コンポーネント(CommonAct.vue)から上がってくるイベント
     *
     * @param {Number} index 音声再生するactのインデックス
     */
    clickSound: function(index) {
      // 音声認識中の場合、音声ファイルのパスを保持しておき、中断後に再生する
      if (sonic_wrapper.isSessionRunning()) {
        this.soundPath = this.pathstep.acts[index].sounds[0];
        this.log("------ interruptSession :: soundPath " + this.soundPath);
        sonic_wrapper.interruptSession();
      } else {
        this.autoPlay(this.pathstep.acts[index].sounds[0], 10);
        this.soundPlay = true;
        this.soundPlaying = false;
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        clones.textArea = clones.card.children("div").children("p");
        clones.textArea.empty();
        clones.textArea.append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // 対象となるテキストを取得する
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item > div > p");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
      // 出題文表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $("#toparea").css({
        height: rootHeight - headerHeight - footerHeight - cardsContainerHeight
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/card";

.toparea-mic {
  .item {
    width: 300px;
    word-wrap: break-word;
    white-space: normal;
    position: relative;
    cursor: default;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }
    &::-webkit-scrollbar {
      width: 10px;
      background-color: $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $dgray;
      border: 2px solid $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }

    .mic-icon {
      z-index: 2;
      background: url(#{$imgpath}mic/mic_base.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
      margin: 5px 0;
    }
    .mic-icon.score_1 {
      background: url(#{$imgpath}mic/mic_01.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_2 {
      background: url(#{$imgpath}mic/mic_02.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_3 {
      background: url(#{$imgpath}mic/mic_03.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_4 {
      background: url(#{$imgpath}mic/mic_04.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_5 {
      background: url(#{$imgpath}mic/mic_05.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_6 {
      background: url(#{$imgpath}mic/mic_06.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_7 {
      background: url(#{$imgpath}mic/mic_07.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_8 {
      background: url(#{$imgpath}mic/mic_08.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_9 {
      background: url(#{$imgpath}mic/mic_09.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_10 {
      background: url(#{$imgpath}mic/mic_10.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// P.vue?62915348